import React, { Fragment } from "react";
import __ from "lodash";
import moment from "moment";
import {withStyles} from "@material-ui/core/styles";
import {Typography} from "@material-ui/core";
import Season from "./Season";

const formatDays = (days) => {
  let scrDays = "";
  for (let i=0; i < days.length; i++) {
    scrDays += days.charAt(i) === '.' ? "0" : `${i+1}`;
  }
  return scrDays;
}

const getOverNight = (arrival, departure) => {
  if (arrival === "HHMM" || departure === "HHMM")
    return "";
  const arrivalTime = moment(arrival, "HHmm");
  const departureTime = moment(departure, "HHmm");

  return departureTime.isBefore(arrivalTime) ? "1" : "";
}

function chunkSubstr(str, size) {
  const numChunks = Math.ceil(str.length / size);
  const chunks = new Array(numChunks);

  for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
    chunks[i] = str.substr(o, size);
  }

  return chunks;
}

const renderSupplement = (supplement) => {
  const maxSiLineLength = 65;
  const chunks =  chunkSubstr(supplement, maxSiLineLength);

  return(
    chunks.map(chunk => {
      return <Fragment><span>{`SI ${chunk}`}</span><br/></Fragment>
    })
  );
}

const renderGeneral = (general) => {
  const maxGiLineLength = 65;
  const chunks =  chunkSubstr(general, maxGiLineLength);

  return(
    chunks.map((chunk, i) => {
      return <Fragment>{i === 0 ? <span>{`GI ${chunk}`}</span> : chunk}<br/></Fragment>
    })
  );
}

const getSlotLevel = (slotLevelInfo, from) => {
  if (slotLevelInfo && Array.isArray(slotLevelInfo) && from) {
    for (let i = 0; i < slotLevelInfo.length; i++) {
      const season = slotLevelInfo[i];
      if (moment.utc(from).isBetween(moment.utc(season.seasonsStarts), moment.utc(season.seasonsEnds)))
        return (__.has(season, "slotLevel") && !__.isEmpty(season.slotLevel) && season.slotLevel.includes("(2)") ? "SMA" : "SCR");
    }
  } else if (typeof slotLevelInfo === "string") {
    if (["SCR", "SMA"].includes(slotLevelInfo))
      return slotLevelInfo
  }

  return "SCR";
}


const ScrMessageView = (props) => {
  const slot = __.cloneDeep(props.slot);
  const originalSlot =  __.cloneDeep(props.originalSlot);
  if (!slot)
    return <></>;

  const renderScr = (slot, lineOnly, referenceSlot, parentDirection) => {
    const turnround = __.has(slot, "slotType") && !__.isEmpty(slot.slotType) && slot.slotType !== "TURNROUND" ? false : true;
    const hasReference = __.has(slot, "slotReference") && !__.isEmpty(slot.slotReference);
    const requestTime = __.has(slot, "requestedTime") && slot.requestedTime ? moment(slot.requestedTime).format("DDMMM").toUpperCase() : moment().format("DDMMM").toUpperCase();
    const airport = __.has(slot, "airportCode") && !__.isEmpty(slot.airportCode) ? slot.airportCode : "{Request Airport}";
    // const slotLevel = __.has(slot, "slotLevel") && !__.isEmpty(slot.slotLevel) && slot.slotLevel.includes("(2)") ? "SMA" : "SCR";
    const slotLevel = getSlotLevel(slot.slotLevel, slot.slotPeriodFrom);
    const separator = "\u00A0";
    const action = __.has(slot, "slotActionCode") && !__.isEmpty(slot.slotActionCode) ? slot.slotActionCode : "{ActionCode}";
    const inboundFlight = slot.slotDirection === "DEPARTURE" ? "" : (__.has(slot, "arrivalAirlineCode") && !__.isEmpty(slot.arrivalAirlineCode) ? slot.arrivalAirlineCode + slot.arrivalFlightNo : "{Arrival Flight}");
    const outboundFlight = slot.slotDirection === "ARRIVAL" ? "" : (__.has(slot, "departureAirlineCode") && !__.isEmpty(slot.departureAirlineCode) ? slot.departureAirlineCode + slot.departureFlightNo : "{Departure Flight}");
    const aircraftType = "00074Y";
    const origin = slot.slotDirection === "DEPARTURE" ? "" : __.has(slot, "originAirportCode") && !__.isEmpty(slot.originAirportCode) ? slot.originAirportCode : "{Origin}";
    const arrivalTime = slot.slotDirection === "DEPARTURE" ? "" : (__.has(slot, "arrivalTime") && !__.isEmpty(slot.arrivalTime) ? slot.arrivalTime.replace(":","").substring(0,4) : "{Arrival Time}");
    const departureTime = slot.slotDirection === "ARRIVAL" ? "" : __.has(slot, "departureTime") && !__.isEmpty(slot.departureTime) ? slot.departureTime.replace(":","").substring(0,4) : "{Departure Time}";
    const overnight = __.has(slot, 'offsetDays') ? slot.offsetDays<1?"":slot.offsetDays : slot.slotDirection !== "ARRIVAL" && slot.slotDirection !== "DEPARTURE"? getOverNight (arrivalTime, departureTime) : "";
    const destination = slot.slotDirection === "ARRIVAL" ? "" : (__.has(slot, "destinationAirportCode") && !__.isEmpty(slot.destinationAirportCode) ? slot.destinationAirportCode : "{Destination}");
    const arrivalService = slot.slotDirection === "DEPARTURE" ? "" : __.has(slot, "arrivalService") && !__.isEmpty(slot.arrivalService) ? slot.arrivalService : "{Arrival Service}";
    const departureService = slot.slotDirection === "ARRIVAL" ? "" : (__.has(slot, "departureService") && !__.isEmpty(slot.departureService) ? slot.departureService : "{Departure Service}") ;
    const frequency = __.has(slot, "frequency") ? (slot.frequency === "BI-WEEKLY" ? "2" : "") : "";
    const supplement = __.has(slot, "supplementInfo") && !__.isEmpty(slot.supplementInfo) ? slot.supplementInfo : "";
    const general = __.has(slot, "generalInfo") && !__.isEmpty(slot.generalInfo) ? slot.generalInfo : "";
    const aircraft = __.has(slot, "aircraftTailNumber") && !__.isEmpty(slot.aircraftTailNumber) ? "RA." + slot.aircraftTailNumber.replace("-","") : "";
    const additionalInfo = !__.isEmpty(aircraft); // Add additional items if we add support for those
    const changeFromDate = __.has(slot, "slotChangePeriodFrom") && slot.slotChangePeriodFrom ? moment(slot.slotChangePeriodFrom).format("DDMMM").toUpperCase() : "{From}";
    const changeToDate = (__.has(slot, "slotChangePeriodTo") && slot.slotChangePeriodTo ? moment(slot.slotChangePeriodTo).format("DDMMM").toUpperCase() : "{To}");
    const changeDays = (__.has(slot, "changeDays") && !__.isEmpty(slot.changeDays) ? formatDays(slot.changeDays) : "0000000");
    let fromDate = (__.has(slot, "slotPeriodFrom") && slot.slotPeriodFrom ? moment(slot.slotPeriodFrom).format("DDMMM").toUpperCase() : "{From}");
    let toDate = (__.has(slot, "slotPeriodTo") && slot.slotPeriodTo ? moment(slot.slotPeriodTo).format("DDMMM").toUpperCase() : "{To}");
    let days = (__.has(slot, "days") && !__.isEmpty(slot.days) ? formatDays(slot.days) : "0000000");

    if (referenceSlot) {
      referenceSlot["slotPeriodFrom"] = fromDate;
      referenceSlot["slotPeriodTo"] = toDate;
      if (!props.resend) {
        fromDate = changeFromDate;
        toDate = changeToDate;
        days = changeDays;
      }
    }

    return (
      <Fragment>
        {props.suppressTitle || lineOnly? <></> : <div><Typography color="inherit">Slot Request Message</Typography><br/></div>}
        <div style={{ whiteSpace: "pre-wrap" }}>
          {!lineOnly
            ?
              <div>
                <span>{slotLevel}</span><br/>
                {hasReference ? <span>{`/${slot.slotReference}`}</span>: <></>}{hasReference ? <br/> : <></>}
                <Season slotFrom={slot.slotPeriodFrom} code/>
                <span style={requestTime.includes("{")?{color: "red"}:{}}>{requestTime}</span><br/>
                <span style={airport.includes("{")?{color: "red"}:{}}>{airport}</span><br/>
              </div>
            :
              <></>
          }

          {referenceSlot ? renderScr (referenceSlot, true, null, slot.slotDirection) : <></>}

          {turnround
            ?
              <div>
                <span style={action.includes("{")?{color: "red"}:{}}>{action}</span>
                {(!lineOnly && slot.slotDirection === "ARRIVAL") || (lineOnly && parentDirection === "ARRIVAL")
                  ?
                    <Fragment>
                      <span style={inboundFlight.includes("{")?{color: "red"}:{}}>{inboundFlight}</span>
                      <span>{separator}</span>
                      <span style={fromDate.includes("{")?{color: "red"}:{}}>{fromDate}</span>
                      <span style={toDate.includes("{")?{color: "red"}:{}}>{toDate}</span>
                      <span>{separator}</span>
                      <span>{days}</span>
                      <span>{separator}</span>
                      <span>{aircraftType}</span>
                      <span>{separator}</span>
                      <span style={origin.includes("{")?{color: "red"}:{}}>{origin}</span>
                      <span style={arrivalTime.includes("{")?{color: "red"}:{}}>{arrivalTime}</span>
                      <span>{separator}</span>
                      <span style={arrivalService.includes("{")?{color: "red"}:{}}>{arrivalService}</span>
                    </Fragment>
                  :
                    <></>
                }
                {(!lineOnly && slot.slotDirection === "DEPARTURE") || (lineOnly && parentDirection === "DEPARTURE")
                  ?
                    <Fragment>
                      <span>{separator}</span>
                      <span style={outboundFlight.includes("{")?{color: "red"}:{}}>{outboundFlight}</span>
                      <span>{separator}</span>
                      <span style={fromDate.includes("{")?{color: "red"}:{}}>{fromDate}</span>
                      <span style={toDate.includes("{")?{color: "red"}:{}}>{toDate}</span>
                      <span>{separator}</span>
                      <span>{days}</span>
                      <span>{separator}</span>
                      <span>{aircraftType}</span>
                      <span>{separator}</span>
                      <span style={departureTime.includes("{")?{color: "red"}:{}}>{departureTime}</span>
                      <span>{overnight}</span>
                      <span style={destination.includes("{")?{color: "red"}:{}}>{destination}</span>
                      <span>{separator}</span>
                      <span style={departureService.includes("{")?{color: "red"}:{}}>{departureService}</span>
                    </Fragment>
                  :
                    <></>
                }
                {(!lineOnly && slot.slotDirection !== "ARRIVAL" && slot.slotDirection !== "DEPARTURE") || (lineOnly && parentDirection !== "ARRIVAL" && parentDirection !== "DEPARTURE")
                  ?
                    <Fragment>
                      <span style={inboundFlight.includes("{")?{color: "red"}:{}}>{inboundFlight}</span>
                      <span>{separator}</span>
                      <span style={outboundFlight.includes("{")?{color: "red"}:{}}>{outboundFlight}</span>
                      <span>{slot.slotDirection !== "ARRIVAL" ? separator : ""}</span>
                      <span style={fromDate.includes("{")?{color: "red"}:{}}>{fromDate}</span>
                      <span style={toDate.includes("{")?{color: "red"}:{}}>{toDate}</span>
                      <span>{separator}</span>
                      <span>{days}</span>
                      <span>{separator}</span>
                      <span>{aircraftType}</span>
                      <span>{separator}</span>
                      <span style={origin.includes("{")?{color: "red"}:{}}>{origin}</span>
                      <span style={arrivalTime.includes("{")?{color: "red"}:{}}>{arrivalTime}</span>
                      <span>{slot.slotDirection !== "DEPARTURE" ? separator : ""}</span>
                      <span style={departureTime.includes("{")?{color: "red"}:{}}>{departureTime}</span>
                      <span>{overnight}</span>
                      <span style={destination.includes("{")?{color: "red"}:{}}>{destination}</span>
                      <span>{separator}</span>
                      <span style={arrivalService.includes("{")?{color: "red"}:{}}>{arrivalService}</span>
                      <span style={departureService.includes("{")?{color: "red"}:{}}>{departureService}</span>
                    </Fragment>

                  :
                    <></>
                }

                <span>{separator}</span>
                <span>{frequency}</span><br/>
                {additionalInfo ?  <span>{`/ ${aircraft}/`}</span> : <></>}
                {additionalInfo ?  <br/> : <></>}
              </div>
            :
              <div>
                {(!lineOnly && slot.slotDirection !== "DEPARTURE") || (lineOnly && parentDirection !== "DEPARTURE")
                  ?
                    <div>
                      <span style={action.includes("{") ? {color: "red"} : {}}>{action}</span>
                      <span style={inboundFlight.includes("{") ? {color: "red"} : {}}>{inboundFlight}</span>
                      <span>{separator}</span>
                      <span style={fromDate.includes("{") ? {color: "red"} : {}}>{fromDate}</span>
                      <span>{separator}</span>
                      <span>{aircraftType}</span>
                      <span>{separator}</span>
                      <span style={origin.includes("{") ? {color: "red"} : {}}>{origin}</span>
                      <span style={arrivalTime.includes("{") ? {color: "red"} : {}}>{arrivalTime}</span>
                      <span>{separator}</span>
                      <span style={arrivalService.includes("{") ? {color: "red"} : {}}>{arrivalService}</span><br/>
                      {additionalInfo ? <span>{`/ ${aircraft}/`}</span> : <></>}
                      {additionalInfo ? <br/> : <></>}
                    </div>
                  :
                    <></>
                }

                {
                  (!lineOnly && slot.slotDirection !== "ARRIVAL") || (lineOnly && parentDirection !== "ARRIVAL")
                    ?
                      <div>
                        <span style={action.includes("{")?{color: "red"}:{}}>{action}</span>
                        <span>{separator}</span>
                        <span style={outboundFlight.includes("{")?{color: "red"}:{}}>{outboundFlight}</span>
                        <span>{separator}</span>
                        <span style={toDate.includes("{")?{color: "red"}:{}}>{toDate}</span>
                        <span>{separator}</span>
                        {aircraftType}
                        <span>{separator}</span>
                        <span style={departureTime.includes("{")?{color: "red"}:{}}>{departureTime}</span>
                        <span style={destination.includes("{")?{color: "red"}:{}}>{destination}</span>
                        <span>{separator}</span>
                        <span style={departureService.includes("{")?{color: "red"}:{}}>{departureService}</span><br/>
                        {additionalInfo ?  <span>{`/ ${aircraft}/`}</span> : <></>}
                        {additionalInfo ?  <br/> : <></>}
                      </div>
                    :
                      <></>
                }
              </div>
          }

          {!lineOnly
            ?
              <div>
                {supplement !== "" ? renderSupplement(supplement) : <></>}
                {/*{general !== "" ? <span>{`GI ${general}`}</span> : <></>}{general !== "" ? <br/> : <></>}*/}
                {general !== "" ? renderGeneral(general) : <></>}
                <br/>
              </div>
            :
             <></>
          }

        </div>

      </Fragment>
    )
  }

  // if ( ! __.has(slot, "direction")) {
  //   slot["direction"] =
  // }

  let reference = null;
  if (__.has(slot, "slotActionCode") && !__.isEmpty(slot.slotActionCode) && ["C", "M"].includes(slot.slotActionCode)) {
    originalSlot["slotActionCode"] = slot["slotActionCode"];
    slot["slotActionCode"] = "R"; // Code R is used to inform the coordinator that, if the required slot is not available, the airline will accept a different offer from the one requested if this leads to an improvement in their current situation.
    reference =  originalSlot;
  }

  return (renderScr (slot, false, reference));
}

export default ScrMessageView;
